/**
 * @generated SignedSource<<123a6d1af7385899ac424bae6730e60f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type LogoutSisenseUserInput = {
  sisenseUserId?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type LogoutSisenseUserMutation$variables = {
  input: LogoutSisenseUserInput;
};
export type LogoutSisenseUserMutation$data = {
  readonly logoutSisenseUser: {
    readonly success: boolean | null;
  } | null;
};
export type LogoutSisenseUserMutation = {
  variables: LogoutSisenseUserMutation$variables;
  response: LogoutSisenseUserMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "LogoutSisenseUserPayload",
    "kind": "LinkedField",
    "name": "logoutSisenseUser",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "LogoutSisenseUserMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "LogoutSisenseUserMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "92bf055edb1134c8b1818b64ae881505",
    "id": null,
    "metadata": {},
    "name": "LogoutSisenseUserMutation",
    "operationKind": "mutation",
    "text": "mutation LogoutSisenseUserMutation(\n  $input: LogoutSisenseUserInput!\n) {\n  logoutSisenseUser(input: $input) {\n    success\n  }\n}\n"
  }
};
})();

(node as any).hash = "f6cf14eceb953a651f830b8cbc9965c2";

export default node;
